class Environment {
    static BuildConfirmOrderPickupEndpoint(orderId:string | undefined): string
    {
        return Environment.GetSaasEndpoint() + "confirmPickUpArrival/" + orderId;
    }

    static BuildOrdersforUserEndpoint(): string
    {
        return Environment.GetSaasEndpoint() + "ordersForUser";
    }

    static BuildOrderJsonEndpoint(orderId:string | undefined): string
    {
        return Environment.GetSaasEndpoint() + "orderJson/" + orderId;
    }

    static GetOrderUrl(): string
    {
        return Environment.GetSaasEndpoint() + "orders";
    }

    static BuildSpecificOrderUrl(orderId:string | undefined): string
    {
        return Environment.GetSaasEndpoint() + "orders/" + orderId;
    }

    static BuildConfirmEndPickupEndpoint(orderId:string | undefined): string
    {
        return Environment.GetSaasEndpoint() + "confirmEndPickUpLoading/" + orderId; 
    }

    static BuildGetSignaturesEndpoint(orderId:string | undefined): string
    {
        return Environment.GetSaasEndpoint() + "signatures/" + orderId;
    }

    static GetUserOrdersUrl(): string
    {
        return Environment.GetSaasEndpoint() + "user/orders";
    }

    static GetCreateorderUrl() : string
    {
        return Environment.GetTMSEndpoint() + "createOrder";
    }

    static GetProtectedUrl() : string
    {
        return Environment.GetSaasEndpoint() + "protected";
    }

    static GetAuthClientId(): string
    {
        return window.extended ? window.extended.REACT_APP_AUTH_CLIENT_ID : "9BKIhZhEs1hSpHsaR3rqP9eHgfCWtYlS";
    }

    static GetAuthDomain(): string
    {
        return window.extended ? window.extended.REACT_APP_AUTH_DOMAIN : "dev-qyohtcrqusya7jly.eu.auth0.com";
    }

    static GetAuthAudience(): string
    {
        return window.extended ? window.extended.REACT_APP_AUTH_AUDIENCE : "https://hello-world.example.com";
    }

    static GetAuthScope(): string
    {
        return window.extended ? window.extended.REACT_APP_AUTH_SCOPE : "openid profile email read:current_user update:current_user_metadata";
    }

    private static GetSaasEndpoint(): string
    {
        return window.extended ? window.extended.REACT_APP_DIGIDROP_SAAS_ENDPOINT : "http://localhost:8080/";
    }

    private static GetTMSEndpoint(): string
    {
        return window.extended ? window.extended.REACT_APP_TMS_ENDPOINT : "http://localhost:8082/";
    }


}

export default Environment;